(function () {
  'use strict';

  var FOCUSABLE = 'a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])';

  /* ---------------- the detail drawer ----------------
     One element for the whole page, created on first open. Each card carries
     its own body in a <template>, which is cloned in here — a template's
     contents are inert, so none of those portraits are fetched until someone
     actually asks for that person. */
  var drawer = null, drawerBody = null, opener = null;

  function lenis(method) {
    var l = window.lenisScroll && window.lenisScroll.lenis;
    if (l && typeof l[method] === 'function') l[method]();
  }

  function buildDrawer() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'cza-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="cza-drawer__scrim" data-cza-close></div>' +
      '<div class="cza-drawer__panel" data-lenis-prevent>' +
        '<button class="cza-drawer__close" type="button" data-cza-close>' +
          '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
            '<path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1.3" fill="none"/>' +
          '</svg>' +
          '<span class="cza-sr">Close</span>' +
        '</button>' +
        '<div class="cza-drawer__body"></div>' +
      '</div>';
    document.body.appendChild(drawer);
    drawerBody = drawer.querySelector('.cza-drawer__body');

    drawer.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-cza-close]')) closeDrawer();
    });
  }

  function openDrawer(card, trigger) {
    var tpl = card.querySelector('[data-cza-detail]');
    if (!tpl) return;

    buildDrawer();
    opener = trigger;

    drawerBody.textContent = '';
    drawerBody.appendChild(tpl.content.cloneNode(true));

    var label = card.querySelector('.cza-person__name');
    if (label) drawer.setAttribute('aria-label', label.textContent.trim());

    drawer.hidden = false;
    document.documentElement.classList.add('cza-locked');
    lenis('stop');
    // next frame, so the transition has a start state to run from
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    });

    var close = drawer.querySelector('.cza-drawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cza-locked');
    lenis('start');

    var done = function () {
      drawer.hidden = true;
      drawerBody.textContent = '';   // stop any media the panel was holding
      if (opener) { opener.focus(); opener = null; }
    };

    var panel = drawer.querySelector('.cza-drawer__panel');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!panel || reduce) { done(); return; }

    var fired = false;
    var once = function () { if (!fired) { fired = true; done(); } };
    panel.addEventListener('transitionend', once, { once: true });
    // transitionend does not fire if the element was never painted
    setTimeout(once, 700);
  }

  document.addEventListener('keydown', function (e) {
    if (!drawer || drawer.hidden) return;

    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;

    // keep the tab ring inside the panel while it is modal
    var items = drawer.querySelectorAll(FOCUSABLE);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- team slider ---------------- */
  function initSlider(root) {
    var track = root.querySelector('[data-cza-track]');
    var prev = root.querySelector('[data-cza-prev]');
    var next = root.querySelector('[data-cza-next]');
    if (!track || !prev || !next) return;

    function step() {
      var slide = track.querySelector('.cza-team__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;   // exactly one card
    }

    var ticking = false;
    function sync() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      });
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    else window.addEventListener('resize', sync);

    sync();
  }

  /* ---------------- wiring ----------------
     Every root is initialised on its own and flagged once done, so duplicating
     a section in the editor gives two working sliders rather than one. */
  function initRoot(root) {
    if (root.dataset.czaReady === 'true') return;
    root.dataset.czaReady = 'true';

    Array.prototype.forEach.call(root.querySelectorAll('[data-cza-open]'), function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-cza-person]');
        if (card) openDrawer(card, btn);
      });
    });

    if (root.querySelector('[data-cza-track]')) initSlider(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cza-root]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // the editor replaces a section's markup wholesale on every edit
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { closeDrawer(); });
})();
